<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                  <label style="font-weight: bold; font-style: italic"
                    >Mã phiếu:
                  </label>
                  <br />
                  <label
                    style="
                      font-weight: bold;
                      font-style: italic;
                      padding-right: 1%;
                    "
                    ><span>Trạng thái: </span>
                    <span>Nháp</span>
                  </label>
                </CCol>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                  <div style="float: right">
                    <CButton
                      color="secondary"
                      class="btn-action-primary mr-2"
                      @click="$router.go(-1)"
                      ><i class="fa fa-reply"></i>
                      Quay lại
                    </CButton>
                    <CButton
                      color="primary"
                      class="btn-action-primary"
                      @click="submitData()"
                    >
                      <i class="fa fa-save"></i> Lưu lại
                    </CButton>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                  <CRow>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect
                        :options="inventoryTypeSelect.options"
                        :data="inventoryTypeSelect.data"
                        ref="inventoryTypeSelect"
                      ></BaseSelect>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseSelect
                        :options="warehouseSelect.options"
                        :data="warehouseSelect.data"
                        ref="warehouseSelect"
                      ></BaseSelect>
                    </CCol>
                    <CCol
                      xs="12"
                      sm="12"
                      md="6"
                      lg="6"
                      xl="6"
                      v-if="inventoryTypeSelect.data.model == 'out'"
                    >
                      <BaseSelect
                        :options="customerSelect.options"
                        :data="customerSelect.data"
                        ref="customerSelect"
                      ></BaseSelect>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <div class="form-group" style="width: 100%">
                        <CRow>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <label for="datepicker"
                              >Ngày chứng từ
                              <span class="required">* </span>
                            </label>
                          </CCol>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <div>
                              <DatePicker
                                id="inventoryDate"
                                v-model="inventoryDateInput.data.model"
                                locale="vi"
                                class="datepicker"
                                :input-props="{ readonly: true }"
                                :masks="{
                                  input: 'DD/MM/YYYY',
                                  data: 'DD/MM/YYYY',
                                }"
                                :popover="{ visibility: 'click' }"
                              >
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                                    readonly
                                  />
                                </template>
                              </DatePicker>
                              <div
                                class="valid-error"
                                v-show="
                                  !(inventoryDateInput.data.validator
                                    ? inventoryDateInput.data.validator.isValid
                                    : true)
                                "
                              >
                                {{
                                  inventoryDateInput.data.validator
                                    ? inventoryDateInput.data.validator
                                        .errorMessage
                                    : ""
                                }}
                              </div>
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <div class="form-group" style="width: 100%">
                        <CRow>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <label for="datepicker"
                              >Ngày tính bảo hành
                              <span class="required">* </span>
                            </label>
                          </CCol>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <div>
                              <DatePicker
                                id="inventoryDate"
                                v-model="warrantyDateInput.data.model"
                                locale="vi"
                                class="datepicker"
                                :input-props="{ readonly: true }"
                                :masks="{
                                  input: 'DD/MM/YYYY',
                                  data: 'DD/MM/YYYY',
                                }"
                                :popover="{ visibility: 'click' }"
                              >
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                                    readonly
                                  />
                                </template>
                              </DatePicker>
                              <div
                                class="valid-error"
                                v-show="
                                  !(warrantyDateInput.data.validator
                                    ? warrantyDateInput.data.validator.isValid
                                    : true)
                                "
                              >
                                {{
                                  warrantyDateInput.data.validator
                                    ? warrantyDateInput.data.validator
                                        .errorMessage
                                    : ""
                                }}
                              </div>
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <BaseInput
                        :options="quantityInput.options"
                        :data="quantityInput.data"
                      />
                    </CCol>
                    <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                      <div class="form-group" style="width: 100%">
                        <CRow>
                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <label>{{ totalPriceInput.options.label }}</label>
                          </CCol>

                          <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                            <div>
                              <currency-input
                                :disabled="totalPriceInput.options.disabled"
                                class="form-control"
                                v-model="totalPriceInput.data.model"
                                currency="VND"
                                locale="vi"
                              />
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                    </CCol>
                    <CCol xs="12" sm="12" md="10" lg="10" xl="10" v-if="inventoryTypeSelect.data.model == 'in'">
                      <div class="form-group">
                        <label class="form-label">Nhập mới</label>
                        <CInputCheckbox
                          custom
                          :checked="isNewCheckBox.data.model"
                          class="ml-2"
                          @update:checked="changeIsNew($event)"
                          addInputClasses="override-custom"
                        >
                        </CInputCheckbox>
                      </div>
                    </CCol>

                    <CCol sm="12" md="12" xl="12">
                      <BaseTextArea
                        :options="descriptionInput.options"
                        :data="descriptionInput.data"
                        v-model="descriptionInput.data.model"
                      />
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <StockInventoryLines
      :products="stockLineSelect.data.model"
      :removeListLine="[]"
      :isDone="false"
      @sum-total="sumTotal($event)"
    />

    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>
  
<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea";
import { DatePicker } from "v-calendar";
import StockInventoryLines from "../stock/StockInventoryLines";

export default {
  name: "StockAdd",
  components: {
    BaseSelect,
    BaseInput,
    BaseLoading,
    BaseTextArea,
    DatePicker,
    StockInventoryLines,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      isNewCheckBox: {
        options: {
          label: "Nhập mới",
        },
        data: {
          name: "isNew",
          model: false,
          updateCallback: function () {
            that.submitData();
          },
        },
      },
      quantityInput: {
        options: {
          label: "Tổng số lượng",
          placeholder: "Tổng số lượng",
          maxlength: 64,
          disabled: true,
        },
        data: {
          name: "quantity",
          model: 0,
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              return this.isValid;
            },
          },
        },
      },
      totalPriceInput: {
        options: {
          label: "Tổng tiền",
          placehder: "Tổng tiền",
          type: "text",
          disabled: true,
        },
        data: {
          name: "totalPrice",
          model: 0,
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              return this.isValid;
            },
          },
        },
      },
      descriptionInput: {
        options: {
          label: "Ghi chú",
          placeholder: "Ghi chú",
          maxlength: 512,
          rows: 5,
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              // let value = that.descriptionInput.data.model;
              // if (value === "" || value.trim() === "") {
              //     this.isValid = false;
              //     this.errorMessage = "Ghi chú bản tin không được để trống";
              // } else {
              //     this.isValid = true;
              // }
              return this.isValid;
            },
          },
        },
      },
      warehouseSelect: {
        options: {
          filter: true,
          label: "Kho <span class='required'>*</span>",
          selectAllText: "Chọn kho",
          keyField: "value",
          valueField: "text",
        },
        data: {
          name: "warehouseId",
          items: [],
          model: null,
          source: {
            url: "/warehouse/list-warehouse",
            dataSubmit: function () {
              return {};
            },
            response: function (dataResponse) {
              that.warehouseSelect.data.items = dataResponse.data;
            },
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.warehouseSelect.data.model;
              if (!value || value === "") {
                this.isValid = false;
                this.errorMessage = "Kho không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      customerSelect: {
        options: {
          filter: true,
          label: "Khách hàng <span class='required'>*</span>",
          selectAllText: "Chọn khách hàng",
          keyField: "value",
          valueField: "text",
        },
        data: {
          name: "customerId",
          items: [],
          model: null,
          source: {
            url: "/customer/list-customer",
            dataSubmit: function () {
              return {};
            },
            response: function (dataResponse) {
              that.customerSelect.data.items = dataResponse.data;
            },
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              if ("out" == that.inventoryTypeSelect.data.model) {
                let value = that.customerSelect.data.model;
                if (!value || value === "") {
                  this.isValid = false;
                  this.errorMessage = "Khách hàng không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
              }

              return this.isValid;
            },
          },
        },
      },
      inventoryTypeSelect: {
        options: {
          filter: false,
          label: "Loại phiếu <span class='required'>*</span>",
        },
        data: {
          name: "inventoryType",
          items: [
            { key: "in", value: "Nhập kho" },
            { key: "out", value: "Xuất kho" },
          ],
          model: "in",
          updateCallback: function () {
            that.submitData();
          },
        },
      },
      inventoryDateInput: {
        options: {
          label: "Ngày chứng từ <span class='required'>*</span>",
        },
        data: {
          name: "inventoryDate",
          model: new Date(),
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.inventoryDateInput.data.model;
              if (!value || value === "") {
                this.isValid = false;
                this.errorMessage = "Ngày chứng từ không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      warrantyDateInput: {
        options: {
          label: "Ngày tính bảo hành <span class='required'>*</span>",
        },
        data: {
          name: "warrantyDate",
          model: new Date(),
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.warrantyDateInput.data.model;
              if (!value || value === "") {
                this.isValid = false;
                this.errorMessage = "Ngày chứng từ không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            },
          },
        },
      },
      stockLineSelect: {
        options: {
          label: "Dòng chi tiết",
        },
        data: {
          name: "stockLines",
          model: [],
        },
      },
    };
  },
  methods: {
    changeIsNew(event) {
        this.isNewCheckBox.data.model = event;
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.warehouseSelect.data.validator.valid();
      isValid &= this.customerSelect.data.validator.valid();
      isValid &= this.inventoryDateInput.data.validator.valid();
      isValid &= this.warrantyDateInput.data.validator.valid();

      let errorMessage = "";
      for (var i = 0; i < that.stockLineSelect.data.model.length; i++) {
        if (!that.stockLineSelect.data.model[i].productId) {
          errorMessage += "Dòng " + (i + 1) + " sản phẩm bắt buộc nhập \n";
          isValid = false;
        }
        if (that.stockLineSelect.data.model[i].quantity <= 0) {
          errorMessage += "Dòng " + (i + 1) + " số lượng phải lớn hơn 0 \n";
          isValid = false;
        }
      }

      if (errorMessage.length > 0) {
        that.showErrorMsg({ message: errorMessage });
      }

      if (!isValid) {
        return;
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/stock/create",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Tạo mới phiếu thành công",
            });
            // that.$router.go(-1);
            that.$router.push(
              `/stock-management/${response.data.data.id}/update.html`
            );
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    sumTotal() {
      let totalPrice = 0;
      let totalQuantity = 0;
      for (let i = 0; i < this.stockLineSelect.data.model.length; i++) {
        totalQuantity += this.stockLineSelect.data.model[i].quantity * 1;
        totalPrice +=
          this.stockLineSelect.data.model[i].unitPrice *
          this.stockLineSelect.data.model[i].quantity;
      }
      this.totalPriceInput.data.model = totalPrice;
      this.quantityInput.data.model = totalQuantity;
    },
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>